import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { ApiResponse } from '@card-software/nexus-utilities';
import { Parameter } from '../../models/engineering/parameter';

@Injectable({
  providedIn: 'root',
})
export class ParameterProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.itemApi + '/api/v1/parameter';

  public getParameters(): Observable<ApiResponse<Parameter[]>> {
    return this.httpClient.get<ApiResponse<Parameter[]>>(`${this.baseUrl}/all`);
  }

  public getParameterById(parameterId: string): Observable<ApiResponse<Parameter>> {
    return this.httpClient.get<ApiResponse<Parameter>>(`${this.baseUrl}/${parameterId}`);
  }

  public upsertParameter(parameter: Parameter): Observable<ApiResponse<Parameter>> {
    return this.httpClient.post<ApiResponse<Parameter>>(`${this.baseUrl}`, parameter);
  }

  public deleteParameter(parameterId: string): Observable<ApiResponse<void>> {
    return this.httpClient.delete<ApiResponse<void>>(`${this.baseUrl}/${parameterId}`);
  }
}
